<script setup>

import RestaurantHeading from "@/views/restaurant/components/RestaurantHeading.vue";
import RestaurantMenu from "@/views/restaurant/components/RestaurantMenu.vue";
import {getCurrentInstance, onMounted, reactive} from "vue";
const { $axios } = getCurrentInstance().appContext.config.globalProperties;
const { $endpoint } = getCurrentInstance().appContext.config.globalProperties;
const retaurantPageData = reactive({});

onMounted(()=>{
  $axios.get($endpoint.LoadRestaurant).then((resp_restaurant_data)=>{
    Object.assign(retaurantPageData, resp_restaurant_data.data);
  });
  console.log(retaurantPageData);
})
</script>

<template>
<restaurant-heading v-if="retaurantPageData && retaurantPageData.restaurantHero"
                    :appointment="retaurantPageData?.appointment"
                    :restaurant-hero="retaurantPageData?.restaurantHero"
                    :presentation="retaurantPageData?.presentation"
></restaurant-heading>
  <restaurant-menu v-if="retaurantPageData && retaurantPageData.menus" :menu-list="retaurantPageData?.menus" :menu-title="retaurantPageData?.menuTitle" ></restaurant-menu>
</template>

<style scoped>

</style>